module.exports = __webpack_public_path__ + "img/triangle.0ef24945.svg";